import { z } from 'zod';
export const ValXmlBulkExportLinkSchema = z.string();
export const NewPortfolioSchema = z.object({
    title: z.string(),
    customer_uuid: z.string(),
    closing_date: z.string().optional(),
});
export const PortfolioSchema = NewPortfolioSchema.extend({
    uuid: z.string(),
    type: z.enum(['portfolio', 'synthetic']),
    created_on: z.string(),
    updated_on: z.string(),
    assets: z.array(z.string()),
});
export const PortfolioListSchema = z.object({
    portfolios: z.array(PortfolioSchema),
});
